/* ============================================================
   YOOME HOME — behaviour for the yh-* homepage sections.
   Add-to-bag buttons reuse .product-card__quick-add, which yoome.js
   already handles (adds to cart and opens the cart drawer).
   ============================================================ */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---- Scroll reveal ----
  var revealObserver = null;
  if (!reducedMotion && 'IntersectionObserver' in window) {
    document.documentElement.classList.add('yh-anim');
    revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  }

  function initReveal(root) {
    var items = root.querySelectorAll('[data-yh-reveal]');
    items.forEach(function (el) {
      if (revealObserver) revealObserver.observe(el);
      else el.classList.add('is-in');
    });
  }

  // ---- Tabs ----
  function initTabs(root) {
    root.querySelectorAll('[data-yh-tabs]').forEach(function (section) {
      var tabs = Array.prototype.slice.call(section.querySelectorAll('[role="tab"]'));
      if (!tabs.length) return;

      function select(tab, focus) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.setAttribute('tabindex', on ? '0' : '-1');
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (!panel) return;
          if (on) {
            panel.removeAttribute('hidden');
            // Cards in a hidden panel were never observed into view.
            panel.querySelectorAll('[data-yh-reveal]').forEach(function (el) { el.classList.add('is-in'); });
          } else {
            panel.setAttribute('hidden', '');
          }
        });
        if (focus) tab.focus();
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(tab, false); });
        tab.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
          else if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
          else if (e.key === 'Home') next = tabs[0];
          else if (e.key === 'End') next = tabs[tabs.length - 1];
          if (next) { e.preventDefault(); select(next, true); }
        });
      });

      section._yhSelectTab = function (blockId) {
        var tab = tabs.filter(function (t) { return t.dataset.blockId === blockId; })[0];
        if (tab) select(tab, false);
      };
    });
  }

  // ---- Gift finder ----
  function initGiftFinder(root) {
    root.querySelectorAll('[data-yh-gift]').forEach(function (section) {
      var whoChips = Array.prototype.slice.call(section.querySelectorAll('[data-yh-who]'));
      var budgetChips = Array.prototype.slice.call(section.querySelectorAll('[data-yh-budget]'));
      var go = section.querySelector('[data-yh-go]');
      var summary = section.querySelector('[data-yh-summary]');
      var baseUrl = section.dataset.baseUrl || '/collections/all';
      var sort = section.dataset.sort || '';
      var who = null;
      var budget = null;

      function esc(s) {
        return String(s).replace(/[&<>"']/g, function (c) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
      }

      function update() {
        var url = who ? who.dataset.url : baseUrl;
        var params = [];
        if (budget) {
          if (budget.dataset.min && budget.dataset.min !== '0') params.push('filter.v.price.gte=' + encodeURIComponent(budget.dataset.min));
          if (budget.dataset.max) params.push('filter.v.price.lte=' + encodeURIComponent(budget.dataset.max));
        }
        if (sort) params.push('sort_by=' + encodeURIComponent(sort));
        if (go) go.href = url + (params.length ? (url.indexOf('?') > -1 ? '&' : '?') + params.join('&') : '');
        if (summary) {
          var whoText = who ? who.dataset.label : summary.dataset.whoDefault;
          var budgetText = budget ? budget.dataset.label : summary.dataset.budgetDefault;
          summary.innerHTML = 'Gifts for <b>' + esc(whoText) + '</b>, <b>' + esc(budgetText) + '</b>';
        }
      }

      function toggle(list, chip, current) {
        var next = current === chip ? null : chip;
        list.forEach(function (c) { c.setAttribute('aria-pressed', c === next ? 'true' : 'false'); });
        return next;
      }

      whoChips.forEach(function (chip) {
        chip.addEventListener('click', function () { who = toggle(whoChips, chip, who); update(); });
      });
      budgetChips.forEach(function (chip) {
        chip.addEventListener('click', function () { budget = toggle(budgetChips, chip, budget); update(); });
      });
      update();
    });
  }

  // ---- Mystery box ----
  function initMystery(root) {
    root.querySelectorAll('[data-yh-mystery]').forEach(function (section) {
      var box = section.querySelector('[data-yh-mbox]');
      var card = section.querySelector('[data-yh-reveal-card]');
      var poolEl = section.querySelector('[data-yh-pool]');
      if (!box || !card || !poolEl) return;

      var pool = [];
      try { pool = JSON.parse(poolEl.textContent) || []; } catch (e) { pool = []; }
      if (!pool.length) { box.disabled = true; return; }

      var img = card.querySelector('[data-yh-reveal-img]');
      var title = card.querySelector('[data-yh-reveal-title]');
      var link = card.querySelector('[data-yh-reveal-link]');
      var again = card.querySelector('[data-yh-again]');
      var last = -1;
      var busy = false;

      function pick() {
        var i = Math.floor(Math.random() * pool.length);
        if (pool.length > 1 && i === last) i = (i + 1) % pool.length;
        last = i;
        return pool[i];
      }

      function open() {
        if (busy) return;
        busy = true;
        card.classList.remove('is-visible');
        box.classList.remove('is-open');
        var item = pick();
        var preload = new Image();
        preload.src = item.image;
        box.classList.add('is-shaking');
        setTimeout(function () {
          box.classList.remove('is-shaking');
          box.classList.add('is-open');
          if (img) { img.src = item.image; img.alt = item.title; }
          if (title) title.textContent = item.title + ' · ' + item.price;
          if (link) link.href = item.url;
          card.classList.add('is-visible');
          busy = false;
        }, reducedMotion ? 0 : 700);
      }

      box.addEventListener('click', open);
      if (again) again.addEventListener('click', open);
    });
  }

  // ---- Store hours: highlight today ----
  // Lines look like "Mon: 10am–5pm", "Mon–Wed: 10am–5pm" or "Sat & Sun: 10am–5pm".
  function initStores(root) {
    var days = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
    var today = new Date().getDay();
    root.querySelectorAll('[data-yh-hours] dt').forEach(function (dt) {
      var text = (dt.dataset.days || '').toLowerCase();
      var range = text.split(/\s*[–—-]\s*|\s+to\s+/);
      var hit = false;
      if (range.length === 2) {
        var a = days.indexOf(range[0].trim().slice(0, 3));
        var b = days.indexOf(range[1].trim().slice(0, 3));
        if (a > -1 && b > -1) {
          for (var d = a; ; d = (d + 1) % 7) {
            if (d === today) { hit = true; break; }
            if (d === b) break;
          }
        }
      } else {
        hit = text.split(/\s*(?:,|&|and)\s*/).some(function (part) {
          return days.indexOf(part.trim().slice(0, 3)) === today;
        });
      }
      if (hit) dt.classList.add('is-today');
    });
  }

  // ---- Hero: Build ⇄ Cuddle switch ----
  // Flips between the Rolife and Jellycat sides every few seconds (paused while the pointer is
  // over the hero or the tab is hidden) until a shopper taps the switch.
  function initHeroSwitch(root) {
    root.querySelectorAll('[data-yh-hero]').forEach(function (hero) {
      if (hero._yhSwitch) return;
      hero._yhSwitch = true;
      var tabs = Array.prototype.slice.call(hero.querySelectorAll('[data-world-tab]'));
      if (tabs.length < 2) return;
      var every = (parseFloat(hero.getAttribute('data-auto')) || 0) * 1000;
      var timer = null, chosen = false, hovering = false;

      function show(world, focus) {
        hero.setAttribute('data-world', world);
        tabs.forEach(function (tab) {
          var on = tab.getAttribute('data-world-tab') === world;
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.tabIndex = on ? 0 : -1;
          if (on && focus) tab.focus();
        });
        hero.querySelectorAll('[data-world-panel]').forEach(function (panel) {
          var on = panel.getAttribute('data-world-panel') === world;
          panel.classList.toggle('is-on', on);
          if (on) { panel.removeAttribute('inert'); if (panel.classList.contains('yh-hero__set')) panel.removeAttribute('aria-hidden'); }
          else { panel.setAttribute('inert', ''); if (panel.classList.contains('yh-hero__set')) panel.setAttribute('aria-hidden', 'true'); }
        });
      }
      function other() { return hero.getAttribute('data-world') === 'build' ? 'cuddle' : 'build'; }
      function schedule() {
        window.clearTimeout(timer);
        if (!every || chosen || reducedMotion) return;
        timer = window.setTimeout(function () {
          if (!hovering && !document.hidden) show(other());
          schedule();
        }, every);
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          chosen = true;
          window.clearTimeout(timer);
          show(tab.getAttribute('data-world-tab'));
        });
        tab.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault();
          chosen = true;
          window.clearTimeout(timer);
          show(tabs[(i + 1) % tabs.length].getAttribute('data-world-tab'), true);
        });
      });
      hero.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hovering = true; });
      hero.addEventListener('pointerleave', function () { hovering = false; });

      // theme editor: selecting a product block shows its side and stops the flipping
      hero._yhShowWorld = function (world) { chosen = true; window.clearTimeout(timer); show(world); };
      show(hero.getAttribute('data-world') || 'build');
      schedule();
    });
  }

  // ---- Reviews: on phones they swipe one at a time; the dots follow along ----
  function initReviewDots(root) {
    root.querySelectorAll('.yh-reviews__grid').forEach(function (grid) {
      var dots = grid.parentNode.querySelectorAll('.yh-reviews__dots span');
      if (!dots.length) return;
      grid.addEventListener('scroll', function () {
        var current = Math.round(grid.scrollLeft / Math.max(1, grid.clientWidth));
        dots.forEach(function (dot, n) { dot.classList.toggle('is-on', n === current); });
      }, { passive: true });
    });
  }

  function init(root) {
    initHeroSwitch(root);
    initReveal(root);
    initReviewDots(root);
    initTabs(root);
    initGiftFinder(root);
    initMystery(root);
    initStores(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // ---- Theme editor support ----
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
    e.target.querySelectorAll('[data-yh-reveal]').forEach(function (el) { el.classList.add('is-in'); });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var panel = e.target.closest && e.target.closest('[data-world-panel]');
    var hero = panel && panel.closest('[data-yh-hero]');
    if (hero && hero._yhShowWorld) hero._yhShowWorld(panel.getAttribute('data-world-panel'));
    var section = e.target.closest('[data-yh-tabs]');
    if (section && section._yhSelectTab && e.detail && e.detail.blockId) section._yhSelectTab(e.detail.blockId);
  });
})();
